"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgCameraFilled = function (props) {
    var color = props.color;
    return (react_1.default.createElement("path", { fill: color, fillRule: "evenodd", clipRule: "evenodd", d: "M7.95453 4.32733C8.23881 3.53134 8.99278 3 9.83801 3H14.162C15.0072 3 15.7612 3.53134 16.0455 4.32733L16.2857 5H20C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7C2 5.89543 2.89543 5 4 5H7.71429L7.95453 4.32733ZM20 8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8C18 7.44772 18.4477 7 19 7C19.5523 7 20 7.44772 20 8ZM16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z" }));
};
exports.default = factorySvgIcon_1.default(SvgCameraFilled);
//# sourceMappingURL=SvgCameraFilled.js.map